module.exports = __webpack_public_path__ + "static/media/sponsors.970c47d7.png";